import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { SettingsButton } from "./SettingsButton";

interface SearchSettingsFooterProps {
    selectedPageSizeOption: number;
    onResultsPerPageChange: (numberOfResults: number) => void;
    onColumnOrderingButtonClick?: () => void;
    onClose: () => void;
    onOk: () => void;
    pageSizeOptions?: number[];
    isSaveSettingsChecked?: boolean;
    onSaveSettingsCheckboxChange?: (value: boolean) => void | null;
    footerClassName?: string;
    disableOkButton?: boolean;
}

class SearchSettingsFooter extends BaseReactComponent<SearchSettingsFooterProps, null> {
    private initialSelectedPageSizeOption: number;

    constructor(props: SearchSettingsFooterProps) {
        super(props);
        this.initialSelectedPageSizeOption = props.selectedPageSizeOption;
    }

    public render(): JSX.Element {
        const footerClass = `f-footer flex-container ${this.props.footerClassName}`;
        return (
            <div className={footerClass}>
                <div style={{ alignItems: "center", justifyContent: "flex-start" }} className="flex-container">
                    {this.props.onColumnOrderingButtonClick && (
                        <SettingsButton
                            rightMargin={10}
                            alternativeIcon
                            onClick={() => this.props.onColumnOrderingButtonClick()}
                            dataCyAttribute="searchSettingsFooter-columnOrdering"
                        />
                    )}
                    <select
                        className="form-control"
                        style={{ width: "unset" }}
                        onChange={(e: any) => {
                            const value = parseInt(e.target.value);
                            this.props.onResultsPerPageChange(value);
                        }}
                        value={this.props.selectedPageSizeOption.toString()}
                    >
                        {(this.props.pageSizeOptions || cacheStore.getDefaultPageSizes())
                            .map(size => <option key={size} value={size.toString()}>{size}</option>)
                        }
                    </select>
                    <span style={{ marginLeft: "10px" }}>{cacheStore.GetString("ResultsPerPageLabel").toUpperCase()}</span>
                </div>
                <div className="text-right">
                    {this.props.onSaveSettingsCheckboxChange && (
                        <span className="push-right-5" style={{ marginRight: "20px" }}>
                            <CheckboxControl
                                dataCy="searchSettings-save"
                                label={cacheStore.GetString("RememberUserSettings")}
                                checked={this.props.isSaveSettingsChecked}
                                onChange={checked => this.props.onSaveSettingsCheckboxChange(checked)}
                            />
                        </span>
                    )}
                    <ButtonControl
                        dataCy="searchSettings-cancel"
                        className="btn btn-default push-right-5"
                        onClick={() => {
                            this.props.onResultsPerPageChange(this.initialSelectedPageSizeOption);
                            this.props.onClose();
                        }}
                        label={cacheStore.GetString("CancelLabel")}
                    />
                    <ButtonControl
                        dataCy="searchSettings-ok"
                        className="btn btn-primary"
                        onClick={() => {
                            this.props.onOk();
                        }}
                        label={cacheStore.GetString("Ok_Label")}
                        disabled={!!this.props.disableOkButton}
                    />
                </div>
            </div>
        );
    }
}

export { SearchSettingsFooter, SearchSettingsFooterProps };
